import debug from "debug";
const log = debug('gallery-carousel');

class GalleryCarousel {
	constructor(element, options) {
		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;

		this.init();

		log(element,options);
	}

    init() {

        if (!this.options.thumbsSelector) {
            log(`No thumbsSelector provided. data-gallery-carousel-thumbs-selector="..." Aborting.`);
            return false;
        }

        this.thumbs = document.querySelector(this.options.thumbsSelector);
        if (!this.thumbs) {
            log(`No thumbs found with selector ${this.options.thumbsSelector}. Aborting.`);
            return false;
        }

        this.thumbItems = [...this.thumbs.children];
        if(this.thumbItems.length < 2) {
            return false;
        }

        this.selectedThumb = this.thumbItems[0];
        this.updateSelectionState();

        this.flickity = new Flickity(this.element, {
            contain: this.options.contain,
            arrowShape: this.options.arrowShape,
            pageDots: this.options.pageDots
        });

		this.watch();
    }

	watch() {
		log('watching');

        this.flickity.on("select", this.onSelect.bind(this));
	}

    onSelect() {
        this.selectedThumb = this.thumbItems[this.flickity.selectedIndex];
        this.updateSelectionState();
        this.pauseVideo();
        this.pauseYouTube();
    }

    updateSelectionState() {
        this.thumbItems.forEach((item) => {
            item.dataset.galleryPagerSelected = item === this.selectedThumb;
        });
    }

    pauseYouTube() {
        const players = this.element.querySelectorAll('lite-youtube.lyt-activated');
        players.forEach((element)=>{
            element.getYTPlayer().then(player => {
                if(player && player.pauseVideo) {
                    player.pauseVideo();
                }
            });
        });
    }

    pauseVideo() {
        const videos = this.element.querySelectorAll('video');
        videos.forEach((video) => {
            video.pause();
        });
    }

}

GalleryCarousel.DEFAULTS = {
    contain: true,
    arrowShape: "M74.38,92.74a4.24,4.24,0,1,1-6,6c-.5-.47-1-1-1.45-1.46l-8.87-8.86L31.94,62.29,23.68,54a9,9,0,0,1-1.88-2.21c-1-2-.12-3.9,1.32-5.34L43,26.63,66.08,3.52c.71-.71,1.41-1.42,2.12-2.12,2.24-2.2,6.14-1.73,7.2,1.47s-2.58,5.9-4.62,7.94l-24.6,24.6-11,11-3,3c-.09.09-.56.43-.57.56s.07.08.14.22.58.58.8.81L34,52.35l4.36,4.36L50.88,69.24,73.1,91.46Z",
    pageDots: true
};

export default GalleryCarousel;



// WEBPACK FOOTER //
// ./project/client/src/core/modules/gallery-carousel/gallery-carousel.js